import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import AssetStatusReportWidget from '../../../widgets/durableArticlesWidget/assetStatusReportWidgets/AssetStatusReportWidget'
import { getAssetStatusReportPage } from '../../../redux/actions/addDurableArticles'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'

export default function AssetStatusReportApprover() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const projectCode = sessionGetItemStr('projectCode')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getAssetStatusReportPage(projectCode)
      // console.log('getLegalManagement ', _schema)
      setSchema(_schema.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isIncomeExpenseApprover>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isIncomeExpenseApprover>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isIncomeExpenseApprover>
        <ContentHeader header={schema.header} subHeader={''} isNotCallApi />

        <AssetStatusReportWidget schema={schema} />

        <br />
      </SidebarProposal>
    </div>
  )
}
